<template>
  <div>
    <data-table
      ref="datatable"
      :url="api.ACTIONS.CANCELLATION_REASONS"
      :fields-hidden-add="['id','created_at','updated_at','deleted_at']"
      :fields-hidden-edit="['id','created_at','updated_at','deleted_at']"
      :fields-hidden-main="['deleted_at']"
      :fields-extra-add="fieldsExtra"
      :fields-extra-edit="fieldsExtra"
      :input-types-add="inputTypesAdd"
      :input-types-edit="inputTypesEdit"
      :titles="titles"
      :formatter="formatter"
      :enable-edit="true"
      :enable-delete="true"
      :enable-add="true"
      :title="$t('zonesPage.cancellationReasonsTitle')"
    />
  </div>
  
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import api from "@/constants/api.js";
import moment from "moment";

export default {
  name: "cancellation_reasons",
  title() {
    return this.$t("zonesPage.cancellationReasonsTitle");
  },
  components: { DataTable },
  data() {
    return {
      api,
      // ensure these keys exist for New to send values
      defaultItem: {
        text_en: "",
        text_ar: "",
        show_to_user: false,
        show_to_captain: false,
        show_to_passenger: false,
      },
      fieldsExtra: {
        text_en: "v-text-field",
        text_ar: "v-text-field",
        show_to_user: "v-checkbox",
        show_to_captain: "v-checkbox",
        show_to_passenger: "v-checkbox",
      },
      inputTypesAdd: {
        show_to_user: { color: "primary" },
        show_to_captain: { color: "primary" },
        show_to_passenger: { color: "primary" },
      },
      inputTypesEdit: {
        show_to_user: { color: "primary" },
        show_to_captain: { color: "primary" },
        show_to_passenger: { color: "primary" },
      },
    };
  },
  computed: {
    titles() {
      return {
        text_en: this.$t("zonesPage.textEn"),
        text_ar: this.$t("zonesPage.textAr"),
        show_to_user: this.$t("zonesPage.showToUser"),
        show_to_captain: this.$t("zonesPage.showToCaptain"),
        show_to_passenger: this.$t("zonesPage.showToPassenger"),
        id: this.$t("zonesPage.id"),
        created_at: this.$t("zonesPage.dateCreated"),
        updated_at: this.$t("zonesPage.lastDateUpdated"),
      };
    },
    formatter() {
      const vm = this;
      return {
        created_at(val) {
          if (!val) return vm.$t("zonesPage.notAvailable");
          return moment(val).format("YYYY-MM-DD");
        },
        updated_at(val) {
          if (!val) return vm.$t("zonesPage.notAvailable");
          return moment(val).format("YYYY-MM-DD");
        },
        show_to_user(val) {
          return `\n            <i class="v-icon fa ${val ? 'fa-check' : 'fa-close'}" style="color:${val ? 'green' : 'red'}; font-size: 14px;"></i>\n          `;
        },
        show_to_captain(val) {
          return `\n            <i class="v-icon fa ${val ? 'fa-check' : 'fa-close'}" style="color:${val ? 'green' : 'red'}; font-size: 14px;"></i>\n          `;
        },
        show_to_passenger(val) {
          return `\n            <i class="v-icon fa ${val ? 'fa-check' : 'fa-close'}" style="color:${val ? 'green' : 'red'}; font-size: 14px;"></i>\n          `;
        },
      };
    },
  },
  methods: {},
};
</script>

<style scoped>
</style>


